import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDDs7Mv8Rp5PXuLtuRN4KE0vNDFInI1hmM",
  authDomain: "property-management1.firebaseapp.com",
  databaseURL: "https://property-management1-default-rtdb.firebaseio.com",
  projectId: "property-management1",
  storageBucket: "property-management1.firebasestorage.app",
  messagingSenderId: "668350237177",
  appId: "1:668350237177:web:6574e8805323a4e1e59528"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);